/** @jsxRuntime classic */
/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { css, jsx } from '@emotion/react';

import MuiDialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import GuestBookingInfo from './GuestBookingInfo';
import { copyToClipboard } from '../../utils/clipboard';

export default function CreateBookingDialog({ data, open, onClose }) {
  const { t } = useTranslation();
  if (!data) return null;

  function onClick() {
    const link = `${window.location.origin}/guest-booking/${data.identifier}`;
    copyToClipboard(link);
  }

  return (
    <MuiDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <div
          css={css`
            border-bottom: 1px dashed #ccc;
            padding-bottom: 20px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;
          `}
        >
          <IconButton
            css={css`
              border: 1px solid #6c6c6c;
              border-radius: 0.5rem;
              position: absolute;
              top: 0;
              right: 0;
            `}
            onClick={onClose}
            size="small"
          >
            <CloseOutlinedIcon />
          </IconButton>
          <CheckCircleIcon sx={{ color: 'green', fontSize: 40 }} />
          <Typography
            variant="h6"
            component="div"
            sx={{ mt: 2, textAlign: 'center' }}
          >
            {t('Din mötesinbjudan är nu skapad')}
          </Typography>
          <Typography
            variant="body1"
            component="div"
            sx={{ mt: 0.5, textAlign: 'center' }}
          >
            {t('Kopiera länken och skicka ut till deltagarna')}
          </Typography>
        </div>
        <div>
          <GuestBookingInfo info={data} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" fullWidth onClick={onClick}>
          {t('Kopera länk')}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
}
